import { ModuleProps, CreateModuleProps } from "components";
import { WriteRight as EvaluationsWriteRight } from "@pilot-web/pilot-coastal-segments-evaluations";
import { WriteRight as GroupsWriteRight } from "@pilot-web/pilot-coastal-segments-groups";
import { WriteRight as LocationsWriteRight } from "@pilot-web/pilot-coastal-segments-locations";
import { Routes } from "./Routes";

export const Module: ModuleProps = CreateModuleProps({
    id: "PILOT_COASTAL_SEGMENTS_VIEWS",
    applicationRights: [
        EvaluationsWriteRight,
        GroupsWriteRight,
        LocationsWriteRight
    ],
    title: 'Sertifikatomr&aring;der',
    text: 'Sertifikatomr&aring;der',
    icon: 'map-segments',
    minWidth: 768,
    sequenceNo: 16000,
    showOnDashboardByDefault: false,
    canShowOnDashboard: false,
    routes: Routes,
})
